import React from 'react';
import IconAi from '../../components/images/IconAi.jsx';

const MeetingListHighlight = ({ children, text }) => {
    return (
        <div className='p-4 bg-theme1-goldLight rounded-2xl'>
            <h2 className='text-[16px] font-bold mb-3 mt-3 flex items-center text-theme1-goldDark'>
                <IconAi className='mr-2 stroke-theme1-gold w-[22px] h-[22px]' />
                {text}
            </h2>
            {children}
        </div>
    );
};

export default MeetingListHighlight;
